import React from "react";
import { Line } from "react-chartjs-2";

import { handleGraphClick as handleClick } from "../helpers";

const yAxisTitle = {
    display: true,
    text: 'Buses/ Orders Picked Up',
}

export const AllDensityChart = (density) => {
    const data = {
        labels: density.DateList,
        datasets: [
            {
                label: "Bus Density",
                data: density.BusDensity.ALL,
                fill: false,
                backgroundColor: "rgba(54,162,235,0.4)",
                borderColor: "rgba(54,162,235,1)",
            },
            {
                label: "Order Density",
                data: Object.values(density.OrderDensity.ALL),
                fill: false,
                backgroundColor: "rgba(54,162,235,0.4)",
                borderColor: "rgba(54,162,235,1)",
                borderDash: [5, 5], // This makes the line dashed
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false, // Set to false for better responsiveness
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    boxWidth: 15, // Adjust this value to make the legend blocks smaller
                    boxHeight: 15, // Adjust this value to make the legend blocks smaller
                    font: {
                        size: 12 // You can also adjust the font size if needed
                    }
                },
            },
            title: {
                display: false,
                text: "All Terminals Bus and Order Daily Density",
                fontSize: 20,
            },
        },
        scales: {
            x: {
                ticks: {
                    autoSkip: true,
                    maxTicksLimit: 20,
                },
                grid: {
                    display: true,
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    display: true,
                },
                ticks: {
                    stepSize: 1,
                },
                title: yAxisTitle,
            },
        },
        onClick: (evt, element) => handleClick(evt, element),
        onHover: (evt, element) => handleClick(evt, element)
    }
    return <Line data={data} options={options} />
};

export const ByTerminalDensityChart = (density) => {
    const data = {
        labels: density.DateList,
        datasets: [
            {
                label: "LRD Bus Density",
                data: density.BusDensity.LRD,
                fill: false,
                backgroundColor: "rgba(255,206,86,0.4)",
                borderColor: "rgba(255,206,86,1)",
            },
            {
                label: "LRD Order Density",
                data: Object.values(density.OrderDensity.LRD),
                fill: false,
                backgroundColor: "rgba(255,206,86,0.4)",
                borderColor: "rgba(255,206,86,1)",
                borderDash: [3, 3],
            },
            {
                label: "CKV Bus Density",
                data: density.BusDensity.CKV,
                fill: false,
                backgroundColor: "rgba(255,99,132,0.4)",
                borderColor: "rgba(255,99,132,1)",
            },
            {
                label: "CKV Order Density",
                data: Object.values(density.OrderDensity.CKV),
                fill: false,
                backgroundColor: "rgba(255,99,132,0.4)",
                borderColor: "rgba(255,99,132,1)",
                borderDash: [3, 3],
            },
            {
                label: "DTW Bus Density",
                data: density.BusDensity.DTW,
                fill: false,
                backgroundColor: "rgba(75,192,192,0.8)",
                borderColor: "rgba(75,192,192,1)",
            },
            {
                label: "DTW Order Density",
                data: Object.values(density.OrderDensity.DTW),
                fill: false,
                backgroundColor: "rgba(75,192,192,0.8)",
                borderColor: "rgba(75,192,192,1)",
                borderDash: [3, 3],
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false, // Set to false for better responsiveness
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    boxWidth: 15,
                    boxHeight: 15,
                    font: {
                        size: 12
                    }
                },
            },
            title: {
                display: false,
                text: "By Terminal Bus and Order Daily Density",
                fontSize: 20,
            },
        },
        scales: {
            x: {
                ticks: {
                    autoSkip: true,
                    maxTicksLimit: 20,
                },
                grid: {
                    display: true,
                },
            },
            y: {
                beginAtZero: true,
                grid: {
                    display: true,
                },
                ticks: {
                    stepSize: 1,
                },
                title: yAxisTitle,
            },
        },
        onClick: (evt, element) => handleClick(evt, element)
    };

    return <Line data={data} options={options} />
};
